import { render } from "./GoogleDialogue.vue?vue&type=template&id=64f3bce8&scoped=true&ts=true"
import script from "./GoogleDialogue.vue?vue&type=script&lang=ts"
export * from "./GoogleDialogue.vue?vue&type=script&lang=ts"

import "./GoogleDialogue.vue?vue&type=style&index=0&id=64f3bce8&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f3bce8"]])

export default __exports__